import React from 'react';
import PropTypes from 'prop-types';
import SortableTable from '../SF/table/SortableTable';
import IntakeTableRow from './IntakeTableRow';
import Student from '../studentList/Student';
import { getTenantConfig, getWord } from 'utils/tenant';
import { withLoader } from '../common/withLoader';
import SelectAllCheckbox from '../SF/table/SelectAllCheckbox';

class IntakeTable extends React.Component {

  get headers() {
    return [{
      content: <SelectAllCheckbox
        itemName={this.props.itemName}
        itemIds={this.props.students.map(item => item.id)}
        batchSelectAllEnabled={getTenantConfig('BATCH_ACTION_PROCESSING_ENABLED')}
        selectAllItems={this.props.selectAllStudents}
        selectedItemIds={this.props.selectedStudents} 
        totalItemCount={this.props.totalStudents} />,
      collapsing: true
    }, {
      content: 'Name',
      sortValue: 'fullName'
    }, {
      content: 'Email',
      sortValue: 'email'
    }, {
      content: getWord('mobilePhone')
    }, {
      content: 'Last Updated Date'
    }];
  }

  renderStudent = (student, index) =>
    <IntakeTableRow 
      getStudentFolderLink={this.props.getStudentFolderLink}
      key={index}
      selectStudent={(checked) => this.props.selectStudents(checked, [student.id])}
      student={new Student(student)}
      studentIsSelected={this.props.selectedStudents.findIndex(
        selectedItemId => selectedItemId === student.id) > -1} />

  render() {
    return <SortableTable 
      columnToSort={this.props.columnToSort}
      headers={this.headers}
      itemName={this.props.itemName}
      items={this.props.students}
      itemsPerPage={this.props.studentsPerPage}
      onPageChange={this.props.onPageChange}
      onSortChange={this.props.onSortChange}
      renderItem={this.renderStudent}
      sortDirection={this.props.sortDirection}
      start={this.props.start}
      totalItems={this.props.totalStudents}
      totalSelected={this.props.selectedStudents.length} />
  }
  componentDidUpdate() {
    SF.card.rebindAllCards();
  }
}

IntakeTable.defaultProps = {
  columnToSort: 'fullName',
  sortDirection: 'ASC'
};

IntakeTable.propTypes = {
  columnToSort: PropTypes.string.isRequired,
  getStudentFolderLink: PropTypes.func.isRequired,
  itemName: PropTypes.string.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  selectAllStudents: PropTypes.func.isRequired,
  selectedStudents: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectStudents: PropTypes.func.isRequired,
  sortDirection: PropTypes.string.isRequired,
  start: PropTypes.number.isRequired,
  students: PropTypes.array.isRequired,
  studentsPerPage: PropTypes.number.isRequired,
  totalStudents: PropTypes.number.isRequired
};

export default withLoader(IntakeTable);
